function resolve(type) {
  return IoCContainer.resolve(type);
};

function IoCConfig() {

    IoCContainer
        //Shared
        .register(MessageModal,
            function () {
                return new MessageModal(resolve(ApiClient));
            })

    //Road
    .register(RoadEditModal,
      function() {
        return new RoadEditModal(resolve(ApiClient));
      })
    .register(RoadViewModal,
      function() {
        return new RoadViewModal(resolve(ApiClient));
      })
    .register(RoadMapModal,
      function() {
        return new RoadMapModal(resolve(ApiClient));
      })
    .register(TrackSelectModal,
      function() {
        return new TrackSelectModal(resolve(ApiClient));
      })

    //Emergency
    .register(EmergencyEditModal,
      function() {
        return new EmergencyEditModal(resolve(ApiClient));
      })
    .register(EmergencyViewModal,
      function() {
        return new EmergencyViewModal(resolve(ApiClient));
      })
    .register(EmergencyMapModal,
      function() {
        return new EmergencyMapModal(resolve(ApiClient));
      })
    .register(EmergencyScenariosModal,
      function() {
        return new EmergencyScenariosModal(resolve(ApiClient));
      })

    //VideoCameras
    .register(VideoCameraEditModal,
      function () {
        return new VideoCameraEditModal(resolve(ApiClient));
      })
    .register(VideoCameraMapModal,
      function () {
        return new VideoCameraMapModal(resolve(ApiClient));
      })
    .register(VideoCameraViewModal,
      function () {
        return new VideoCameraViewModal(resolve(ApiClient));
      })

    //WStations
    .register(WStationEditModal,
      function () {
        return new WStationEditModal(resolve(ApiClient));
      })
    .register(WStationHistoryModal,
      function () {
        return new WStationHistoryModal(resolve(ApiClient));
      })
    .register(WStationMapModal,
      function () {
        return new WStationMapModal(resolve(ApiClient));
      })
    .register(WStationViewModal,
      function () {
        return new WStationViewModal(resolve(ApiClient));
      })

    //Localities
    .register(LocalityEditModal,
      function () {
        return new LocalityEditModal(resolve(ApiClient));
      })
    .register(LocalityMapModal,
      function () {
        return new LocalityMapModal(resolve(ApiClient));
      })
    .register(LocalityViewModal,
      function () {
        return new LocalityViewModal(resolve(ApiClient));
      })
    .register(LocalityHistoryModal,
      function () {
        return new LocalityHistoryModal(resolve(ApiClient));
      })

        //WorkTypes
    .register(WorkTypeViewModal,
      function () {
        return new WorkTypeViewModal(resolve(ApiClient));
      })
    .register(WorkTypeEditModal,
      function () {
        return new WorkTypeEditModal(resolve(ApiClient));
        })

        //Materials
        .register(MaterialViewModal,
            function () {
                return new MaterialViewModal(resolve(ApiClient));
            })
        .register(MaterialEditModal,
            function () {
                return new MaterialEditModal(resolve(ApiClient));
            })

    //Contracts
    .register(ContractViewModal,
      function () {
        return new ContractViewModal(resolve(ApiClient));
      })
    .register(ContractEdtiModal,
      function () {
        return new ContractEdtiModal(resolve(ApiClient));
      })

    //Contractors
    .register(ContractorViewModal,
      function () {
        return new ContractorViewModal(resolve(ApiClient));
      })
    .register(ContractorEditModal,
      function () {
        return new ContractorEditModal(resolve(ApiClient));
      })

    //Users
    .register(UserViewModal,
      function () {
        return new UserViewModal(resolve(ApiClient));
      })
    .register(UserEditModal,
      function () {
        return new UserEditModal(resolve(ApiClient));
      })

    //LongObjects
    .register(LongObjectViewModal,
      function () {
        return new LongObjectViewModal(resolve(ApiClient));
      })
    .register(LongObjectEditModal,
      function () {
        return new LongObjectEditModal(resolve(ApiClient));
      })
    .register(LongObjectMapModal,
      function () {
        return new LongObjectMapModal(resolve(ApiClient));
      })

    //SSegments
    .register(SSegmentViewModal,
      function () {
        return new SSegmentViewModal(resolve(ApiClient));
      })
    .register(SSegmentEdtiModal,
      function () {
        return new SSegmentEdtiModal(resolve(ApiClient));
      })
    .register(SSegmentMapModal,
      function () {
        return new SSegmentMapModal(resolve(ApiClient));
      })

    //DotObjects
    .register(DotObjectViewModal,
      function () {
        return new DotObjectViewModal(resolve(ApiClient));
      })
    .register(DotObjectEditModal,
      function () {
        return new DotObjectEditModal(resolve(ApiClient));
      })
    .register(DotObjectMapModal,
      function () {
        return new DotObjectMapModal(resolve(ApiClient));
        })
    .register(DotObjectFreeMapModal,
        function () {
            return new DotObjectFreeMapModal(resolve(ApiClient));
        })

    //DotObjectTypes
    .register(DotObjectTypeViewModal,
        function () {
            return new DotObjectTypeViewModal(resolve(ApiClient));
        })
    .register(DotObjectTypeEditModal,
        function () {
            return new DotObjectTypeEditModal(resolve(ApiClient));
        })

    //Works
    .register(WorkViewModal,
      function () {
        return new WorkViewModal(resolve(ApiClient));
      })
    .register(WorkEditModal,
      function () {
        return new WorkEditModal(resolve(ApiClient));
        })
    .register(WorkMapModal,
        function () {
            return new WorkMapModal(resolve(ApiClient));
        })
    .register(WorkErrorAcceptanceModal,
      function () {
        return new WorkErrorAcceptanceModal(resolve(ApiClient));
      })
     .register(WorkAutoStatusModal,
      function () {
        return new WorkAutoStatusModal(resolve(ApiClient));
      })

    //Vehicles
    .register(VehicleViewModal,
      function () {
        return new VehicleViewModal(resolve(ApiClient));
      })
    .register(VehicleEditModal,
      function () {
        return new VehicleEditModal(resolve(ApiClient));
      })
    .register(VehicleTrackModal,
      function () {
        return new VehicleTrackModal(resolve(ApiClient));
      })
     .register(VehicleHistoryEditModal,
      function () {
          return new VehicleHistoryEditModal(resolve(ApiClient));
      })
    //VehicleOnObjects
    .register(VehicleOnObjectTrackModal,
      function () {
        return new VehicleOnObjectTrackModal(resolve(ApiClient));
      })

    //KC2
    .register(KC2WorkModal,
      function () {
        return new KC2WorkModal(resolve(ApiClient));
      })

    //TableVisiblityOptions
    .register(TableVisiblityOptionsModal,
      function () {
        return new TableVisiblityOptionsModal(resolve(ApiClient));
      })

    .register(ApiClient,
      function() {
        return new ApiClient(Url);
      });

};
